import { Image } from 'expo-image';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import { claimIcon } from '@/assets/images/icons';
import Text from '@/components/Text';
import { useColor } from '@/hooks/useColor';
import { i18n } from '@/utils/i18n';

import BrandedButton from '../buttons/BrandedButton';
import GradientCircularButton from '../buttons/GradientCircularButton';

interface ClaimNpoCardProps {
  npoName?: string;
  title?: string;
  message?: string;
  buttonLabel?: string;
  onButtonPress: () => void;
  style?: StyleProp<ViewStyle>;
}
const ClaimNpoCard = ({
  npoName = 'this',
  title = i18n.t('claim_npo.confirm_title', { NPO_NAME: npoName }),
  message = i18n.t('claim_npo.benefits_message'),
  buttonLabel = i18n.t('claim_npo.claim_button_label', { NPO_NAME: npoName }),
  onButtonPress,
  style = styles.cardContainer
}: ClaimNpoCardProps) => {
  const colors = useColor();

  return (
    <View style={style}>
      <GradientCircularButton disabled size={92}>
        <Image style={styles.icon} source={claimIcon} contentFit={'contain'} />
      </GradientCircularButton>
      <Text fontWeight="700" style={[styles.titleText, { color: colors.titleText }]}>
        {title}
      </Text>
      <Text style={styles.descriptionText}>{i18n.t('claim_npo.benefits_header')}</Text>
      <Text style={styles.descriptionText}>{message}</Text>
      <BrandedButton
        textProps={{ ellipsizeMode: 'middle', numberOfLines: 2 }}
        textStyles={styles.buttonTextStyle}
        style={styles.button}
        onPress={onButtonPress}>
        {buttonLabel}
      </BrandedButton>
    </View>
  );
};

const styles = StyleSheet.create({
  cardContainer: {
    backgroundColor: 'white',
    flexDirection: 'column',
    borderRadius: 20,
    paddingHorizontal: 8,
    paddingBottom: 16,
    paddingTop: 20,
    alignItems: 'center',
    justifyContent: 'center'
  },

  descriptionText: {
    fontSize: 16,
    marginBottom: 12,
    textAlign: 'center'
  },

  titleText: {
    fontSize: 22,
    marginTop: 12,
    marginBottom: 28,
    textAlign: 'center'
  },

  icon: {
    width: 48,
    height: 48
  },

  button: {
    width: '100%',
    backgroundColor: '#FE9E22'
  },

  buttonTextStyle: {
    alignSelf: 'center',
    textAlign: 'center',
    textAlignVertical: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 10
  }
});

export default ClaimNpoCard;
